<ng-container *ngIf="viewModel$ | async as vm">
  <div class="modal-header">
    <h4 class="modal-title">Callback Scheduler</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.close({ result: 'Cross click' })">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <form [formGroup]="callbackForm">
          <div class="row mt-1">
            <label for="callbackdate" class="col-3 col-form-label">Callback Date</label>
            <div class="col-4">
              <input id="callbackdate" type="datetime-local" class="form-control" formControlName="callbackdate" />
            </div>
            <div class="col-2">
              <button type="button" class="btn btn-secondary ml-1" (click)="scheduleCallbacks()">
                Schedule
              </button>
            </div>
            <div class="col-2">
              <button type="button" class="btn btn-secondary ml-1" (click)="cancel()">
                Cancel
              </button>
            </div>
            <div class="col-2 mt-2" *ngIf="this.scheduledText === 'Callback Scheduled'">
              <a class="fas fa-check"> </a>
            </div>
            <div class="col-8 mt-2" *ngIf="
                this.scheduledText !== '' &&
                this.scheduledText !== 'Callback Scheduled'
              ">
              {{ this.scheduledText }}
            </div>
          </div>
          <div *ngIf="!(vm.campaignSchedules?.autoAssign ?? true)">
            <hr />
            <div class="row mt-1">
              <label class="col-4 col-form-label">Scheduled Agents</label>
            </div>
            <table class="col-12">
              <tr *ngIf="vm.campaignSchedules === undefined">
                <td>Loading...</td>
              </tr>
              <tr *ngIf="vm.campaignSchedules === null">
                <td>No Records Found...</td>
              </tr>
              <ng-container *ngIf="!!vm.campaignSchedules">
                <tr>
                  <td style="padding-left: 100px">
                    <div *ngFor="let hour of scheduleHours; let i = index">
                      <div style="float: left; width: 50px; padding-left: 1px" *ngIf="
                          i >= vm.campaignSchedules.startHour &&
                          i < vm.campaignSchedules.finishHour
                        ">
                        {{ hour }}
                      </div>
                    </div>
                  </td>
                </tr>

                <ng-container *ngFor="
                    let item of vm.campaignSchedules.schedules;
                    let count = index
                  ">
                  <tr *ngIf="count < 2 || this.showMore === true">
                    <td>
                      <div style="float: left; width: 100px">
                        {{ item.dte | date:'E d/M' }}
                      </div>
                      <div *ngFor="let subitem of item.daySchedules; let i = index">
                        <div style="
                            float: left;
                            width: 25px;
                            border: 1px solid white;
                          " [ngStyle]="{
                            'background-color':
                              subitem.value > 0 ? 'green' : 'white'
                          }" *ngIf="
                            i >= vm.campaignSchedules.startHour * 2 &&
                            i < vm.campaignSchedules.finishHour * 2
                          " (click)="
                            selectCallbackDateTime(item.dte, subitem.key)
                          ">
                          &nbsp;
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
                <tr *ngIf="showMore === false">
                  <td>
                    <a role="button" class="mt-1" (click)="showMore = true">Show More</a>
                  </td>
                </tr>
              </ng-container>
            </table>
          </div>
          <hr />
          <div class="row mt-1">
            <label class="col-4 col-form-label" for="searchdate">View Existing Callbacks</label>
            <div class="col-3">
              <input id="searchdate" type="date" class="form-control" formControlName="searchdate" />
            </div>
            <div class="col-2">
              <button type="button" class="btn btn-secondary ml-1" (click)="searchCallbacks()">
                Search
              </button>
            </div>
            <table class="table mt-1 table-striped" *ngIf="!!vm.searchDate">
              <thead>
                <tr>
                  <th scope="col">Campaign</th>
                  <th scope="col">Name</th>
                  <th scope="col">Callback Datetime</th>
                  <th scope="col">Agent Datetime</th>
                  <th scope="col">State</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="vm.callbacks === undefined">
                  <td colspan="6">Loading...</td>
                </tr>
                <tr *ngIf="vm.callbacks && vm.callbacks.length === 0">
                  <td colspan="6">No Records Found...</td>
                </tr>
                <tr *ngFor="let r of vm.callbacks">
                  <td class="small">{{ r.campaignDescription }}</td>
                  <td class="small">{{ r.name }}</td>
                  <td class="small">
                    {{ r.cbDatetime | date: "dd/MM/yyyy HH:mm" }}
                  </td>
                  <td class="small">
                    {{ r.cbDatetimeAgent | date: "dd/MM/yyyy HH:mm" }}
                  </td>
                  <td class="small">{{ r.state }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>